// removed by extract-text-webpack-plugin
module.exports = {"form":"magazines_7Dd-r","form-title":"magazines_2eDlL","login-forget":"magazines_3hEsV","active":"magazines_3b5hp","error":"magazines_3BBWt","write-error":"magazines_3JswF","background":"magazines_2mYtl","input-login-style":"magazines_2N51l","checkbox":"magazines_3cb8Z","composition":"magazines_1qLJW","effect":"magazines_1CeB6","loginBall":"magazines_1-MtF","lineVertical":"magazines_35TaZ","lineHorizontal":"magazines_L4cyY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/login/LoginComponent.scss
// module id = 604
// module chunks = 1